import { SectionsKey } from "~/constants/enum";

const PageStruct = {
  id: "sign-up",
  useLayout: true,
  children: [{ id: SectionsKey.SignUp, order: 1 }],
};

export default PageStruct;
